<template>
  <div class="card mt-2">
    <div class="card-header">
      <i class="fa fa-address-book-o"></i> Editar
      Ssv 2314 Cadtr Flag Ws
    </div>

    <b-form ref="form" @submit.prevent="onSubmit" @reset="onReset">

      <ssv2314-cadtr-flag-ws-form :ssv2314CadtrFlagWs="ssv2314CadtrFlagWs" :violations="violations"></ssv2314-cadtr-flag-ws-form>

      <div class="row">
        <div class="form-group col-sm-12 mb-2 mr-1 text-right">
          <button class="btn-sm btn btn-sm btn-outline-success mr-1" type="submit" data-toggle="tooltip" data-placement="bottom" title="Atualizar">
            <i class="fa fa-floppy-o"></i> Atualizar
          </button>

          <button class="btn btn-sm btn-outline-danger mr-1" type="button" data-toggle="tooltip" data-placement="bottom" title="Limpar" @click="onReset()">
            <i class="fa fa-eraser"></i> Limpar
          </button>

          <button class="btn btn-sm btn-outline-dark mr-1" type="button" data-toggle="tooltip" data-placement="bottom" @click="$router.go(-1)" title="Voltar">
            <i class="fa fa-arrow-left"></i> Voltar
          </button>
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  
  import store from "@/store";
  
  import {
    FETCH_SSV2314_CADTR_FLAG_WS_BY_ID,
    UPDATE_SSV2314_CADTR_FLAG_WS,
    RESET_SSV2314_CADTR_FLAG_WS
  } from "@/store/actions.type";
  
  import Ssv2314CadtrFlagWsForm from '@/components/Ssv2314CadtrFlagWsForm';
  
  export default {
    components: {
      Ssv2314CadtrFlagWsForm
    },
  
    data() {
      return {
        violations: {}
      };
    },
  
    props: ['id'],
  
    computed: {
      ...mapGetters(['ssv2314CadtrFlagWs'])
    },
  
    methods: {
      onSubmit() {
        this.violations = {};
        return this.$store.dispatch(UPDATE_SSV2314_CADTR_FLAG_WS, this.id)
          .then(ssv2314CadtrFlagWs => {
          	 this.flash().destroyAll();
               this.flashSuccess("Registro atualizado com sucesso.");
               this.$router.push({ name: 'ssv2314-cadtr-flag-ws-list' });
          })
          .catch(response => {
          	 this.flash().destroyAll();
               this.flashError("Ocorreu um erro ao tentar atualizar o registro.");
            if (response.body.violations) this.violations = response.body.violations;
            throw response.body.message;
          });
      },
      onReset() {
        this.violations = {};
        store.dispatch(RESET_SSV2314_CADTR_FLAG_WS);
      }
    },
  
    async beforeRouteEnter(to, from, next) {
      await store.dispatch(RESET_SSV2314_CADTR_FLAG_WS);
      await store.dispatch(FETCH_SSV2314_CADTR_FLAG_WS_BY_ID, to.params.id);
      return next();
    }
  };
</script>